import { createSelector } from 'reselect';
import { PAGELOAD_KEY } from './constants';

export const getPageloadTraceId = createSelector(
    state => state[PAGELOAD_KEY],
    traceId => traceId,
);
export const getBotInfo = createSelector(
    state => state[PAGELOAD_KEY],
    botInfo => botInfo,
);
